import styled from 'styled-components'
import { LinkWithText } from 'components/Link'
import { COLOR_INTENT } from 'Theme'

export const HoverableLinkWithText = styled(LinkWithText)`
  &:hover {
    color: ${COLOR_INTENT.HEADER.ITEM_WITH_IMAGE_TEXT.HOVER};
  }
`
